import PropTypes from "prop-types";

// Components
import InputValue from "@Layouts/components/InputComponents/InputValue";

// MUI
import { Stack, Typography } from "@mui/material";

export default function MetricInput(props) {
	const {
		title = "Bonus",
		showTitle = false,
		inputData = [
			{
				type: "Percent",
				min: -100,
				max: 100,
				decimalsEditable: true,
				decimals: 2,
			},
			{
				type: "Dollar",
				min: -100000,
				max: 100000,
				decimalsEditable: false,
				decimals: 2,
			},
		],
		inputDefinition = {
			value: 0,
			input: "Percent",
		},
		error = false,
		readOnly = false,
		sxProperties = { maxWidth: "95px" },
		onActionUpdate = () => {},
		onChangeType = () => {},
	} = props;

	return (
		<Stack justifyContent={"center"} alignItems={"center"}>
			{showTitle && (
				<Stack>
					<Typography className="draw-label" mr={0.2}>
						{title}
					</Typography>
				</Stack>
			)}
			<Stack>
				<InputValue
					data={inputData}
					value={inputDefinition?.value || 0}
					defaultType={inputDefinition?.input || "Percent"}
					error={error}
					readOnly={readOnly}
					sx={sxProperties}
					onActionUpdate={(value, input) => onActionUpdate(value, input)}
					onChangeType={(value, input) => onChangeType?.(value, input)}
				/>
			</Stack>
		</Stack>
	);
}
MetricInput.propTypes = {
	title: PropTypes.string,
	showTitle: PropTypes.bool,
	inputData: PropTypes.array,
	inputDefinition: PropTypes.object,
	error: PropTypes.bool,
	readOnly: PropTypes.bool,
	sxProperties: PropTypes.object,
	onActionUpdate: PropTypes.func,
	onChangeType: PropTypes.func,
};
